import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';
import ReactDOM from 'react-dom';

import BufferTabView from 'buffers/BufferTabView';
import ProcessTaskGroupLineageViewer from 'processes/graph-builder-processes/flowchart-viz/ProcessTaskGroupLineageViewer';
import ProcessFlowchartTabState from 'processes/process-details/ProcessFlowchartTabState';
import {renderToDOM} from 'redux-stores/ReduxDOMRender';
import {GRAY_LIGHTER} from 'ui-library/Colors';

export default class ProcessFlowchartTabView extends BufferTabView<ProcessFlowchartTabState> {
  render(): this {
    const props = {
      processId: this.model.get('processId'),
    };

    renderToDOM(
      <div className={classNames('react-tab-container', css(styles.tabBackground))}>
        <ProcessTaskGroupLineageViewer {...props} />
      </div>,
      this.el
    );
    return this;
  }

  remove(): Backbone.View<ProcessFlowchartTabState> {
    ReactDOM.unmountComponentAtNode(this.el);
    return super.remove();
  }
}

ProcessFlowchartTabView.prototype.className = 'buffer-tab buffer-tab--no-padding';

const styles = StyleSheet.create({
  tabBackground: {
    background: GRAY_LIGHTER,
    padding: 0,
    maxHeight: '100%',
    overflow: 'hidden',
  },
});
